import { ThemeRadii } from "styled-system";


export const radiisMap: ThemeRadii = {
	NONE: 0,
	XS: 2,
	S: 4,
	M: 8,
	L: 12,
	XL: 16,
	ROUNDED: "100%"
};
